const PANEL_TABBABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';

export function queryDisclosurePanelTabbables(panel: HTMLElement): HTMLElement[] {
  return Array.from(panel.querySelectorAll<HTMLElement>(PANEL_TABBABLE_SELECTOR)).filter(
    (el) => el.getAttribute('tabindex') !== '-1'
  );
}

export function focusDisclosurePanelStart(panel: HTMLElement): void {
  const tabbables = queryDisclosurePanelTabbables(panel);
  if (tabbables.length > 0) {
    tabbables[0].focus();
  } else {
    panel.focus();
  }
}

export function applyOpenDisclosureDocumentKeydown(
  event: KeyboardEvent,
  options: {
    panel: HTMLElement | undefined;
    trigger: HTMLElement | undefined;
    close: () => void;
  }
): void {
  const { panel, trigger, close } = options;
  if (event.key === 'Escape') {
    close();
    return;
  }
  if (event.key !== 'Tab' || !panel) return;
  const active = document.activeElement as HTMLElement | null;
  if (!active || !panel.contains(active)) return;
  const tabbables = queryDisclosurePanelTabbables(panel);
  if (tabbables.length === 0) return;
  const first = tabbables[0];
  const last = tabbables[tabbables.length - 1];
  if (event.shiftKey) {
    if (active === first) {
      event.preventDefault();
      trigger?.focus();
    }
  } else if (active === last) {
    event.preventDefault();
    trigger?.focus();
  }
}

export function applyDisclosurePanelElementKeydown(event: KeyboardEvent, close: () => void): void {
  if (event.key === 'Escape') {
    event.preventDefault();
    close();
    return;
  }
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.stopPropagation();
  }
}

export function applyDisclosureTriggerKeydownWhenOpen(
  event: KeyboardEvent,
  panel: HTMLElement | undefined,
  close: () => void
): void {
  if (event.key === 'Escape') {
    event.preventDefault();
    close();
    return;
  }
  if (event.key !== 'Tab' || !panel) return;
  const tabbables = queryDisclosurePanelTabbables(panel);
  event.preventDefault();
  if (event.shiftKey) {
    if (tabbables.length > 0) {
      tabbables[tabbables.length - 1].focus();
    } else {
      panel.focus();
    }
  } else {
    focusDisclosurePanelStart(panel);
  }
}
